import React from 'react';

// DJB-121: the per-page icons in public/ draw fixed (black) paths, so an
// <img> couldn't pick up the nav's grey-idle/blue-active tinting. Painting
// currentColor through the SVG as a CSS mask keeps the icon files untouched
// and the tint in CSS. `data-icon` mirrors the source for tests — jsdom's
// CSSOM doesn't reliably retain mask-image.
const MaskIcon = ({ src }) => (
  <span
    className="side-nav-mask-icon"
    data-icon={src}
    style={{ WebkitMaskImage: `url(${src})`, maskImage: `url(${src})` }}
    aria-hidden="true"
  />
);

// navTree stores icon *components* (the nav renders whatever the slot holds),
// so expose a factory that binds a source file to one
export const pageIcon = (src) => {
  const Icon = () => <MaskIcon src={src} />;
  return Icon;
};

export default MaskIcon;
